import PropType from 'prop-types';
import React from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

import { propTypesHeaderSection } from '../../../Header.proptypes';

import Button, { ButtonAppearance } from '../../../../../../../ui/Atoms/Button';
import Collapse, {
  CollapseAppearance,
} from '../../../../../../../ui/Atoms/Collapse';
import Dropdown from '../../../../../../../ui/Atoms/Dropdown';
import { HeaderSection } from './HeaderSection';

import * as S from './HeaderMenu.styles';

export const HeaderMenu = ({
  isMobile,
  moreLabel,
  moreTarget,
  moreUrl,
  sections,
  title,
}) => {
  const Component = isMobile ? Collapse : Dropdown;
  const hasMoreButton = !!moreUrl && !!moreLabel;
  const headerSections = sections || [];

  return (
    <Component
      appearance={CollapseAppearance.MINIMAL}
      content={() => (
        <S.ContentWrapper>
          {headerSections.length && (
            <S.SectionWrapper>
              {headerSections.map((section, index) => (
                <HeaderSection
                  key={`${section}-${index}`}
                  section={section}
                  hasMoreButton={hasMoreButton}
                />
              ))}
            </S.SectionWrapper>
          )}
          {moreUrl && moreLabel && (
            <Button
              appearance={ButtonAppearance.MINIMAL}
              link={moreUrl}
              target={moreTarget}
            >
              {moreLabel}
              <FaChevronRight />
            </Button>
          )}
        </S.ContentWrapper>
      )}
      main={({ open, isOpen }) => (
        <S.MainContainer isOpen={isOpen}>
          <Button
            appearance={ButtonAppearance.MINIMAL}
            isIconOnRight={true}
            onFocus={open}
          >
            <FaChevronDown />
            {title}
          </Button>
        </S.MainContainer>
      )}
    />
  );
};

HeaderMenu.propTypes = {
  isMobile: PropType.bool,
  id: PropType.string,
  moreLabel: PropType.string,
  moreTarget: PropType.string,
  moreUrl: PropType.string,
  sections: PropType.arrayOf(PropType.shape(propTypesHeaderSection)),
  title: PropType.string,
};
